"use strict";

const strf = require("./string.format.js");

const AccountModel = require("./models/event.account.js");
const AccountBalanceModel = require("./models/event.account.balance.js");

/*
 *
 * Log account data
 *
 */

class MetaStreamIOAccountData {
  constructor({ constants, logger, storage, utility } = {}) {
    this.constant = constants;
    this.logger = logger;
    this.account = new AccountModel();
    this.utility = utility;
  }

  reset() {
    this.account = new AccountModel();
  }

  setType(account = null) {
    if (account) {
      this.account.type = account;
      this.logger.log(
        "account",
        this.constant.MetaStreamIO_AccountTypeSet.format(this.account.type)
      );
    } else {
      this.logger.log(
        "account",
        "setAccountType() could not set account type: " + err
      );
    }
  }

  setBalance({ account = null, balance = null } = {}) {
    this.account.balances[account] = new AccountBalanceModel({
      account: account,
      balance: balance,
    });
    return this.account.balances[account];
  }

  setBalances(balances) {
    try {
      balances.forEach((balance) => {
        this.setBalance({
          account: balance.account,
          balance: balance.balances,
        });
      });
    } catch (err) {
      this.logger.error("account", err);
    }
  }
}

module.exports = MetaStreamIOAccountData;
